(function () {
  var IT_MAP = [
    ['Write a review', 'Scrivi una recensione'],
    ['Write A Review', 'Scrivi una recensione'],
    ['Verified Buyer', 'Acquisto verificato'],
    ['Verified buyer', 'Acquisto verificato'],
    ['Verified', 'Verificato'],
    ['Load more', 'Carica altre'],
    ['Show more', 'Mostra di più'],
    ['Read more', 'Leggi di più'],
    ['Based on', 'Basato su'],
    ['Customer Reviews', 'Recensioni clienti'],
    ['Customer reviews', 'Recensioni clienti'],
    ['Most Recent', 'Più recenti'],
    ['Highest Rating', 'Valutazione più alta'],
    ['Lowest Rating', 'Valutazione più bassa'],
    ['Photos', 'Foto'],
    ['Sort by', 'Ordina per'],
    ['No reviews yet', 'Ancora nessuna recensione'],
    ['Be the first to write a review', 'Sii la prima a lasciare una recensione'],
    ['reviews', 'recensioni'],
    ['review', 'recensione']
  ];

  function translateNode(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var text = node.nodeValue;
      if (!text || !text.trim()) return;
      var next = text;
      IT_MAP.forEach(function (pair) {
        if (next.indexOf(pair[0]) !== -1) next = next.split(pair[0]).join(pair[1]);
      });
      if (next !== text) node.nodeValue = next;
    });

    root.querySelectorAll('[aria-label], [title], [placeholder], [value]').forEach(function (el) {
      ['aria-label', 'title', 'placeholder', 'value'].forEach(function (attr) {
        var val = el.getAttribute(attr);
        if (!val) return;
        var out = val;
        IT_MAP.forEach(function (pair) {
          if (out.indexOf(pair[0]) !== -1) out = out.split(pair[0]).join(pair[1]);
        });
        if (out !== val) el.setAttribute(attr, out);
      });
    });
  }

  function syncReviewFallback(root) {
    if (!root) return;
    var fallback = root.querySelector('[data-ac-reviews-fallback]');
    var starsFallback = root.querySelector('[data-ac-stars-fallback]');
    var list = root.querySelector('[data-ac-reviews-list], #klaviyo-reviews-all, .ac-reviews-inline__list');
    var stars = root.querySelector('.klaviyo-star-rating-widget');
    var moreBtn = root.querySelector('[data-ac-reviews-open]');
    var preview = root.querySelector('[data-ac-reviews-preview]');
    if (!fallback) return;

    var hasList =
      list &&
      (list.children.length > 0 || (list.textContent && list.textContent.trim().length > 0));
    var hasStars =
      stars &&
      (stars.children.length > 0 || (stars.textContent && stars.textContent.trim().length > 0));

    if (hasList || hasStars) {
      fallback.hidden = true;
      if (starsFallback) starsFallback.hidden = true;
      root.classList.add('ac-reviews-inline--loaded');
      if (preview) preview.classList.toggle('is-empty', !hasList);
      if (moreBtn) moreBtn.hidden = !hasList;
    } else {
      fallback.hidden = false;
      if (starsFallback) starsFallback.hidden = false;
      root.classList.remove('ac-reviews-inline--loaded');
      if (preview) preview.classList.add('is-empty');
      if (moreBtn) moreBtn.hidden = true;
    }

    translateNode(root);
  }

  function setupDialog(section) {
    var dialog = section.querySelector('[data-ac-reviews-dialog]');
    var body = section.querySelector('[data-ac-reviews-dialog-body]');
    var root = section.querySelector('[data-ac-reviews-root]');
    var preview = section.querySelector('[data-ac-reviews-preview]');
    var list = section.querySelector('[data-ac-reviews-list]');
    var openBtn = section.querySelector('[data-ac-reviews-open]');
    var closeBtn = section.querySelector('[data-ac-reviews-close]');
    if (!dialog || !body || !root || !preview || !list || !openBtn) return;

    function openDialog() {
      body.appendChild(list);
      root.classList.add('ac-reviews-inline--dialog-open');
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      translateNode(dialog);
    }

    function closeDialog() {
      preview.appendChild(list);
      root.classList.remove('ac-reviews-inline--dialog-open');
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    openBtn.addEventListener('click', openDialog);
    if (closeBtn) closeBtn.addEventListener('click', closeDialog);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeDialog();
    });
  }

  function init() {
    document.querySelectorAll('.ac-reviews-inline').forEach(function (root) {
      syncReviewFallback(root);
      var list = root.querySelector('[data-ac-reviews-list], #klaviyo-reviews-all');
      var stars = root.querySelector('.klaviyo-star-rating-widget');
      if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function () {
          syncReviewFallback(root);
        });
        if (list) observer.observe(list, { childList: true, subtree: true, characterData: true });
        if (stars) observer.observe(stars, { childList: true, subtree: true, characterData: true });
      }
    });

    document.querySelectorAll('.ac-pdp-assist').forEach(setupDialog);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    setTimeout(init, 800);
    setTimeout(init, 2500);
  });
})();
